import axios from "axios";
import { IS_MULTISWAP, defaultEndPointDetails } from "../utils/const.utils";

export function getNetworkInformationForPublicUser(id) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/networks?ferrumNetworkIdentifier=${id}`
  );
}

export function getAllNetworksApi() {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/networks/list?${
      IS_MULTISWAP ? "isAllowedOnMultiSwap" : "isAllowedOnGateway"
    }=true&isActive=&offset=0&limit=100&isPagination=true&sortKey=createdAt&sortOrder=1`
  );
}
